import { createUseStyles } from "react-jss";
import { ITheme } from "../../../types/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  dailyCard: {
    display: "flex",
    flexDirection: "column",
    background: theme.colors.background4,
    borderRadius: theme.radius.small,
    border: `1px solid ${theme.colors.border1}`,
    padding: theme.spacing.space8,
    gap: theme.spacing.space8,
    "&.fullWidth": {
      flexDirection: "row",
      padding: `${theme.spacing.space8}px`,
      display: "grid",
      gap: theme.spacing.space8,
      gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    },
    "&.collected": {
      background: theme.colors.background3,
    },
    "&.active": {
      border: `1px solid ${theme.colors.border3}`,
    },
  },
  icon: {
    color: theme.colors.text3,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    border: `1.5px solid ${theme.colors.border2}`,
    width: 20,
    height: 20,
    boxSizing: "border-box",
    "&.active": {
      color: theme.colors.text1,
      background: theme.colors.primary,
      border: `1.5px solid ${theme.colors.border4}`,
    },
  },
  gemIcon: {
    width: 24,
    height: 24,
    "&.collected": {
      opacity: 0.3,
    },
  },
  rewardContent: {
    background: theme.colors.background2,
    borderRadius: theme.radius.small,
    padding: `${theme.spacing.space12}px 0`,
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    gap: theme.spacing.space8,
    "&.collected": {
      background: theme.colors.background2,
    },
    "&.fullWidth": {
      padding: `${theme.spacing.space12}px ${theme.spacing.space20}px `,
    },
  },
  rewardDay: {
    display: "flex",
    placeItems: "center",
    textTransform: "capitalize",
    justifyContent: "space-between",

    "&.fullWidth": {
      alignSelf: "center",
      flexDirection: "column",
      alignItems: "center",
      width: "100%",
      gap: theme.spacing.space8,
      justifyContent: "space-around",
    },
    "&.unavailable": {
      justifyContent: "center",
    },
  },
  treasureIcon: {
    width: 76,
    height: 76,
  },
  fullWidthTitle: {
    display: "flex",
    justifyContent: "space-between",
    width: "90%",
    alignItems: "center",
    "&.unavailable": {
      justifyContent: "center",
    },
  },
  fullWidthGem: {
    display: "flex",
    alignItems: "center",
  },
}));
